export default {
    createcourse:{},
    courseList: [],
    courseDetails : {}
}